import React from "react";
import { useUser } from "../context/userContext";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { addComment, getComments, addLike, getChatId } from "./../api/axios";
const Icon = ({ icon, action }) => {
  return (
    <i
      className="fa fa-heart text-2xl cursor-pointer"
      aria-hidden="true"
      onClick={() => {
        action();
      }}
    ></i>
  );
};
const ResourecePost = ({
  name,
  problem,

  links,
  usn,

  _id,

  user,
  innerRef,
  comments = [],
  likes = [],
  demo,
}) => {
  const me = useUser();
  const navigate = useNavigate();
  const [commentsI, setCommentsI] = React.useState([]);
  const [comment, setComment] = React.useState("");

  const [embed, setEmbed] = React.useState(
    links[0].replace("/watch?v=", "/embed/")
  );
  const [like, setLike] = React.useState(
    !demo && (likes.find((m) => me.user._id) || []).length !== 0
  );
  const [likeNumber, setLikeNumber] = React.useState(likes?.length);
  const [currComments, setCurrComments] = React.useState(0);
  const addComments = () => {
    addComment({
      comment,
      Post: _id,
      userId: me.user._id,
      name: me.user.username,

      access: me.token,
    })
      .then((res) => {
        // console.log(res.data);
        if (res.data.comment) setCommentsI((p) => [res.data.comment, ...p]);
        else {
          throw Error("comment not created");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setComment("");
      });
  };
  const likeFn = () => {
    addLike({ _id, access: me.token }).then((res) => {
      setLike(res.data.like);
      setLikeNumber((prev) => {
        if (res.data.like) {
          return prev + 1;
        }
        return prev - 1;
      });
    });
  };
  const getCommentsFun = () => {
    const arr = comments.slice(
      currComments,
      Math.min(comments.length, currComments + 5)
    );
    // console.log(arr);
    getComments({ data: arr, access: me.token }).then((res) => {
      setCurrComments((c) => c + 5);
      // console.log(res.data);

      setCommentsI((p) => [...p, ...res.data.comments]);
    });
  };
  return (
    <div
      className={`${` w-5/6 lg:w-2/3   `}flex flex-col shadow-sm  bg-white mx-auto my-3 border-2`}
      ref={innerRef}
    >
      <div className="w-full text-left bg-slate-50 p-1 flex flex-col wrap ">
        <div className="font-bold px-3 py-2">
          <Link to={`/${usn}`}>{usn}</Link>
        </div>
        <div className="text-gray-400 uppercase px-3 ">
          <i className="fa fa-map-marker mr-2" aria-hidden="true"></i>
          {name}
        </div>
      </div>
      <div className="  p-3  object-contain ">
        <iframe
          src={embed}
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          className="mx-auto w-full h-full"
          title="video"
        />
      </div>
      <div className="p-3">{problem}</div>
      <div className="p-3">
        <span className="  inline-flex items-center gap-2">
          <i
            className={`fa fa-heart text-2xl cursor-pointer ${
              like ? "text-red-500" : "text-gray-300 "
            }`}
            aria-hidden="true"
            onClick={() => {
              likeFn();
            }}
          ></i>
          <span className="text-gray-600 font-bold"> {likeNumber}</span>
        </span>
      </div>
      {links.map((l) => {
        return (
          <a className="p-5 " href={l} target="blank">
            {l}
          </a>
        );
      })}

      <div></div>

      {comments && (
        <>
          <div className="">
            {commentsI?.map((c) => {
              return (
                <div key={c._id} className="flex p-3">
                  <div className="font-medium mx-5 ">{c.name}</div>
                  {c.comment}
                </div>
              );
            })}
          </div>
          {currComments < comments.length ? (
            <div
              onClick={() => {
                getCommentsFun();
              }}
              className="text-blue-300  text-center cursor-pointer m-3"
            >{`load ${comments.length - currComments}  comments `}</div>
          ) : (
            <></>
          )}
        </>
      )}

      <div className="flex justify-center">
        <input
          type="text"
          className="p-3 flex-1 outline-none border-t-2 border-x-2 border-gray-100 "
          value={comment}
          placeholder="ADD COMMENTS"
          onChange={({ target }) => {
            setComment(target.value);
          }}
        />
        <i
          className="fa fa-paper-plane p-3 cursor-pointer text-gray-900 hover:bg-slate-50"
          aria-hidden="true"
          onClick={() => {
            addComments();
          }}
        ></i>
      </div>
    </div>
  );
};

export default ResourecePost;
